import { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { addLesson, getAllLessons, updateLesson } from "../../api/lesson";
import GetAdmin from "../../utils/getAdmin";

const AddLessonForm = ({
  setStatus,
  setShowNotification,
  setRefresh,
  edit,
  lessonId,
  lessonData,
  setEdit,
}) => {
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    title: "",
    season: "",
    grade: "",
    book: "",
    lesson: "",
  });

  useEffect(() => {
    if (edit && lessonId) {
      const fetchData = async () => {
        lessonData.map((item) => {
          if (item._id === lessonId) {
            setInitialValues({
              title: item.title,
              season: item.season,
              grade: item.grade,
              book: item.book,
              lesson: item.lesson,
            });
          }
        });
      };
      fetchData();
    } else if (!edit) {
      setInitialValues({
        title: "",
        season: "",
        grade: "",
        book: "",
        lesson: "",
      });
    }
  }, [edit, lessonId, lessonData]);

  const validationSchema = Yup.object({
    title: Yup.string().required("عنوان درس الزامی است"),
    season: Yup.number("شماره فصل حتماً باید به عدد باشد").required(
      "شماره فصل الزامی است"
    ),
    grade: Yup.string().required("انتخاب پایه الزامی است"),
    book: Yup.string().required("انتخاب کتاب الزامی است"),
    lesson: Yup.number().required("شماره درس الزامی است"),
  });

  const handleLessonForm = async (values) => {
    try {
      setLoading(true);

      const response = await GetAdmin();

      const formData = {};
      formData.creator = response.phone;
      formData.title = values.title;
      formData.season = values.season.toString();
      formData.grade = values.grade;
      formData.book = values.book;
      formData.lesson = values.lesson.toString();

      let res;

      if (edit && lessonId) {
        res = await updateLesson(formData, lessonId);
      } else {
        res = await addLesson(formData);
      }

      setShowNotification(true);
      setStatus(res.status);
      setRefresh((prev) => !prev);
    } catch (err) {
      setShowNotification(true);
      setStatus(502);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => handleLessonForm(values)}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleSubmit,
        handleChange,
        setFieldTouched,
      }) => (
        <form onSubmit={handleSubmit} className="max-w-4xl mx-auto w-full">
          <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-8">
            {/* عنوان فرم */}
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-6">
              افزودن درس جدید
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              {/* عنوان درس */}
              <div className="col-span-full">
                <label
                  htmlFor="title"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  عنوان درس
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  className="w-full px-3 py-2 sm:px-4 sm:py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                  placeholder="عنوان درس را وارد کنید..."
                  onChange={handleChange}
                  onBlur={() => setFieldTouched("title")}
                  value={values.title}
                />
                {touched.title && errors.title && (
                  <p className="mt-1 text-xs text-red-600">*{errors.title}</p>
                )}
              </div>

              {/* پایه تحصیلی */}
              <div>
                <label
                  htmlFor="grade"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  پایه تحصیلی
                </label>
                <select
                  id="grade"
                  name="grade"
                  className="w-full px-3 py-2 sm:px-4 sm:py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                  onChange={handleChange}
                  onBlur={() => setFieldTouched("grade")}
                  value={values.grade}
                >
                  <option value="">انتخاب کنید</option>
                  <option value="1">پایه اول</option>
                  <option value="2">پایه دوم</option>
                  <option value="3">پایه سوم</option>
                  <option value="4">پایه چهارم</option>
                  <option value="5">پایه پنجم</option>
                  <option value="6">پایه ششم</option>
                </select>
                {touched.grade && errors.grade && (
                  <p className="mt-1 text-xs text-red-600">*{errors.grade}</p>
                )}
              </div>

              {/* کتاب */}
              <div>
                <label
                  htmlFor="book"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  کتاب
                </label>
                <select
                  id="book"
                  name="book"
                  className="w-full px-3 py-2 sm:px-4 sm:py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                  onChange={handleChange}
                  onBlur={() => setFieldTouched("book")}
                  value={values.book}
                >
                  <option value="">انتخاب کنید</option>
                  <option value="1">ریاضی</option>
                  <option value="2"> فارسی و نگارش</option>
                  <option value="3">علوم</option>
                  <option value="4">قرآن</option>
                  <option value="5">املا</option>
                  <option value="6">هدیه های آسمانی</option>
                  <option value="7">مطالعات اجتماعی</option>
                </select>
                {touched.book && errors.book && (
                  <p className="mt-1 text-xs text-red-600">*{errors.book}</p>
                )}
              </div>

              {/* شماره فصل */}
              <div>
                <label
                  htmlFor="season"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  شماره فصل
                </label>
                <input
                  type="number"
                  id="season"
                  name="season"
                  className="w-full px-3 py-2 sm:px-4 sm:py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                  placeholder="مثال: 1"
                  min="1"
                  onChange={handleChange}
                  onBlur={() => setFieldTouched("season")}
                  value={values.season}
                />
                {touched.season && errors.season && (
                  <p className="mt-1 text-xs text-red-600">*{errors.season}</p>
                )}
              </div>

              {/* شماره درس */}
              <div>
                <label
                  htmlFor="lesson"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  شماره درس
                </label>
                <input
                  type="number"
                  id="lesson"
                  name="lesson"
                  className="w-full px-3 py-2 sm:px-4 sm:py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                  placeholder="مثال: 1"
                  min="1"
                  onChange={handleChange}
                  onBlur={() => setFieldTouched("lesson")}
                  value={values.lesson}
                />
                {touched.lesson && errors.lesson && (
                  <p className="mt-1 text-xs text-red-600">*{errors.lesson}</p>
                )}
              </div>
            </div>

            {/* دکمه ارسال */}
            <div className="mt-6 flex justify-between ">
              <button
                type="submit"
                disabled={loading}
                className="w-full sm:w-auto px-4 py-2 sm:px-6 sm:py-3 bg-blue-600 text-white text-sm sm:text-base font-medium rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-200 transition duration-200 disabled:opacity-50"
              >
                {loading ? "در حال ارسال..." : "ثبت درس"}
              </button>
              {edit ? (
                <button
                  type="reset"
                  className="hover:text-red-700 text-red-500"
                  onClick={() => setEdit(false)}
                >
                  برگشت به ثبت سوال جدید
                </button>
              ) : null}
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default AddLessonForm;
